// src/components/common/ImageUploader/ImageUploader.jsx
import React, { useState, useRef, useEffect } from 'react';
import { IoCloudUploadOutline, IoCloseCircleOutline } from 'react-icons/io5'; // Icons for upload and remove
// import './ImageUploader.css'; // We'll create this CSS next

const ImageUploader = ({ label, imageUrl, onImageChange, onRemoveImage, isLoading }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  // Effect to update previewUrl when imageUrl prop changes (e.g., initial load or successful save)
  useEffect(() => {
    if (imageUrl) {
      setPreviewUrl(imageUrl);
    } else {
      setPreviewUrl(null); // Clear preview if imageUrl is removed or not provided
    }
  }, [imageUrl]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Create a local URL for instant preview
      const localUrl = URL.createObjectURL(file);
      setPreviewUrl(localUrl);

      // Pass the file up to the parent for handling the actual upload
      onImageChange(file);
    }
  };

  const handleRemove = () => {
    setPreviewUrl(null); // Clear local preview
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clear file input
    }
    onRemoveImage(); // Notify parent to clear the image URL
  };

  const handleUploadClick = () => {
    fileInputRef.current.click(); // Trigger hidden file input click
  };

  return (
    <div className="image-uploader-container">
      {label && <label className="image-uploader-label">{label}</label>}
      <div className={`image-upload-box ${isLoading ? 'uploading' : ''}`}>
        {previewUrl ? (
          <>
            <img src={previewUrl} alt="Preview" className="uploaded-image-preview" />
            <button type="button" className="remove-image-button" onClick={handleRemove} disabled={isLoading}>
              <IoCloseCircleOutline />
            </button>
            {isLoading && (
              <div className="upload-spinner"></div>
            )}
          </>
        ) : (
          <div className="upload-placeholder" onClick={handleUploadClick} disabled={isLoading}>
            {isLoading ? (
              <div className="upload-spinner"></div>
            ) : (
              <>
                <IoCloudUploadOutline className="upload-icon" />
                <span>Click to Upload</span>
              </>
            )}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*" // Only accept image files
              style={{ display: 'none' }}
              disabled={isLoading}
            />
          </div>
        )}
      </div>
      {isLoading && <p className="uploading-message">Uploading...</p>}
    </div>
  );
};

export default ImageUploader;